import { InjectionToken } from '@angular/core';
import { ListData } from '@fi-app/components/items-list/list-data.service';

export const FiItemsListSettings = new InjectionToken<ListData<any>>('FiItemsListSettings');
